export const DELIVERY_OPTIONS = [
  {
    key: 'POPSTATION',
    label: 'Pick up at POPStation',
    info: 'Collect on ',
    charges: 'FREE',
    bulk: false
  },
  {
    key: 'NORMAL',
    label: 'Office delivery',
    info: 'Collect from ',
    charges: 'FREE',
    bulk: true
  },
  {
    key: 'RESIDENTIAL',
    label: 'Residential delivery',
    info: 'Collect from ',
    charges: 'FREE',
    bulk: false
  }
];

export const DELIVERY_OPTION_FOR_SER = [
  {
    key: 'SELF_COLLECTION',
    label: 'Self Collection at Roadshow',
    charges: 'FREE',
    bulk: true
  }
];

export const DELIVERY_OPTIONS_CHARGES_KEYS = {
  '1': 'NORMAL',
  '2': 'POPSTATION',
  '3' : 'RESIDENTIAL'
};

export const PAYMENT_OPTIONS = {
  CREDIT_CARD: {
    key: 'CREDIT_CARD',
    label: 'Credit Card',
    info: 'We accept Visa/MasterCard',
    monthlyPayment: true
  },
  BILLING_ACCOUNT: {
    key: 'BILLING_ACCOUNT',
    label: 'Billing Account',
    info: 'Ensure you have sufficient balance',
    monthlyPayment: true
  },
  TECHFUND: {
    key: 'TECHFUND',
    label: 'Tech Funds',
    info: 'Ensure you have sufficient balance',
    monthlyPayment: false
  },
  CREDIT_TERM: {
    key: 'CREDIT_TERM',
    label: 'Credit Term',
    info: 'Ensure you have sufficient balance',
    monthlyPayment: false
  }
};

export const PAYMENT_OPTIONS_TERMINATE_NUMBER = {
  CREDIT_CARD: {
    key: 'CREDIT_CARD',
    label: 'Credit Card',
    info: 'We accept Visa/MasterCard',
    monthlyPayment: true,
    terminateNumber: true
  },
  BILLING_ACCOUNT: {
    key: 'BILLING_ACCOUNT',
    label: 'Billing Account',
    info: 'Ensure you have sufficient balance',
    monthlyPayment: true,
    terminateNumber: true
  }
};

export const POP_STATION_TYPES = [
  { key: 'ZONE', title: 'Zone' },
  { key: 'POSTAL_CODE', title: 'Postal Code' }
];

export const POP_STATION_ZONES = [
  {
    key: 'ALL',
    label: 'All',
    value: 'all'
  },
  {
    key: 'CENTRAL',
    label: 'Central',
    value: 'central'
  },
  {
    key: 'NORTH',
    label: 'North',
    value: 'north'
  },
  {
    key: 'NORTH EAST',
    label: 'North East',
    value: 'north-east'
  },
  {
    key: 'EAST',
    label: 'East',
    value: 'east'
  },
  {
    key: 'WEST',
    label: 'West',
    value: 'west'
  }
];

export const DEFAULT_MAP_CONFIG = {
  center: {
    lat: 1.285394,
    lng: 103.845084
  },
  zoom: 11
};

export const POP_STATION_BLOCK_LIST = ['P83'];

export const ENROLLMENT_TYPE_MAP_CONFIG = [
  { text: "Credit Card", value: "CreditCard" },
  { text: "GIRO Payment", value: "GiroPayment" }
]
